'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils_configContext = require('./config-context.js');

function useCommonClassName() {
  var {
    classPrefix
  } = utils_configContext["default"];
  return {
    SIZE: {
      default: "",
      xs: "".concat(classPrefix, "-size-xs"),
      small: "".concat(classPrefix, "-size-s"),
      medium: "".concat(classPrefix, "-size-m"),
      large: "".concat(classPrefix, "-size-l"),
      xl: "".concat(classPrefix, "-size-xl"),
      block: "".concat(classPrefix, "-size-full-width")
    },
    STATUS: {
      loading: "".concat(classPrefix, "-is-loading"),
      disabled: "".concat(classPrefix, "-is-disabled"),
      focused: "".concat(classPrefix, "-is-focused"),
      success: "".concat(classPrefix, "-is-success"),
      error: "".concat(classPrefix, "-is-error"),
      warning: "".concat(classPrefix, "-is-warning"),
      selected: "".concat(classPrefix, "-is-selected"),
      active: "".concat(classPrefix, "-is-active"),
      checked: "".concat(classPrefix, "-is-checked"),
      current: "".concat(classPrefix, "-is-current"),
      hidden: "".concat(classPrefix, "-is-hidden"),
      visible: "".concat(classPrefix, "-is-visible"),
      expanded: "".concat(classPrefix, "-is-expanded"),
      indeterminate: "".concat(classPrefix, "-is-indeterminate")
    }
  };
}

exports["default"] = useCommonClassName;
//# sourceMappingURL=use-common-classname.js.map
